import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import withTranslations from '@wheelbox/lithejs-i18n';
import { goto } from '@wheelbox/lithejs-router';
import { GitlabIcon, ArrowRightIcon } from '@wheelbox/lithejs-lucide';

import { Button } from '@wheelbox/lithejs-ui';
import { AnimatedTerminal } from '@components/shared';

export interface CTASectionProps {
  id?: string;
  testId?: string;
}

const CTASection: LitheFC<CTASectionProps> = ({
  id = 'cta-section',
  testId = 'cta-section',
}): LitheElement<'section'> => {
  const t = withTranslations('Home');

  return [
    'section',
    {
      id,
      'data-testid': testId,
      class: 'py-20 px-4 bg-gradient-to-br from-primary to-primary/80',
    },
    [
      'div',
      { class: 'max-w-4xl mx-auto text-center' },
      [
        'h2',
        {
          class: 'text-3xl md:text-4xl font-bold text-primary-foreground mb-4',
        },
        t('cta.title'),
      ],
      [
        'p',
        { class: 'text-lg text-primary-foreground/80 mb-8' },
        t('cta.subtitle'),
      ],
      [
        'div',
        { class: 'flex flex-col sm:flex-row gap-4 justify-center mb-12' },
        Button(
          {
            variant: 'secondary',
            size: 'lg',
            onclick: () => goto('/tutorial'),
          },
          t('cta.button'),
          ArrowRightIcon({ size: 20, classes: 'ml-2' })
        ),
        Button(
          {
            variant: 'outline',
            size: 'lg',
            onclick: () => window.open('https://gitlab.com/lithejs', '_blank'),
            classes: 'bg-white/10 border-white/20 text-white hover:bg-white/20',
          },
          GitlabIcon({ size: 20, classes: 'mr-2' }),
          t('cta.gitlab')
        ),
      ],
      AnimatedTerminal({
        id: `${id}-terminal`,
        commands: [
          { text: 'npx create-lithejs-app my-awesome-app', delay: 100 },
          { text: 'cd my-awesome-app', delay: 50 },
          {
            text: 'npm run dev',
            delay: 50,
            output: '✓ Ready on http://localhost:5173',
          },
        ],
        class: 'max-w-xl mx-auto text-left',
        loop: false,
      }),
    ],
  ];
};

export default CTASection;
